function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { z } from 'zod';
import { findByType } from "../../../data";
import { useRequirementPageAggregatedData, useRequirementPageMutation } from "./aggregatedData";
import { FormDefinition } from "../../../components/DynamicForm";
import { Workflow } from "../types";
export function useRequirementTemplate() {
  var _useRequirementPageAg = useRequirementPageAggregatedData({
      select: function select(data) {
        var requirement = findByType(data.included, 'hybrid');
        if (!requirement) {
          return;
        }
        return _objectSpread({
          id: requirement.id
        }, requirement.attributes);
      }
    }),
    data = _useRequirementPageAg.data,
    isLoading = _useRequirementPageAg.isLoading,
    error = _useRequirementPageAg.error;
  return {
    requirementTemplate: data,
    isLoadingRequirementTemplate: isLoading,
    errorLoadingRequirementTemplate: error
  };
}
export var RequirementTemplatePostRequest = z.object({
  data: z.object({
    type: z.literal('requirement_template_creation_request'),
    attributes: z.object({
      title: z.string(),
      internal_title: z.string(),
      internal_description: z.string().optional(),
      category: z.string(),
      tags: z.string().array(),
      classification: z.string(),
      application_stage: z.string(),
      description: z.string(),
      flags: z.object({
        optional: z["boolean"](),
        applyboard_requirement: z["boolean"](),
        applyproof_compatible: z["boolean"](),
        early_access: z["boolean"](),
        official: z["boolean"](),
        requires_form_preparation: z["boolean"]()
      }),
      external_links: z.array(z.object({
        link: z.string(),
        id: z.number().optional()
      })),
      published: z["boolean"](),
      evaluation_workflow: Workflow.nullable(),
      form_definition: FormDefinition.nullable()
    })
  })
});
export var RequirementTemplatePatchRequest = z.object({
  data: z.object({
    type: z.literal('requirement_template_update_request'),
    attributes: z.object({
      title: z.string(),
      internalTitle: z.string(),
      internalDescription: z.string().optional(),
      category: z.string(),
      tags: z.string().array(),
      classification: z.string(),
      applicationStage: z.string(),
      description: z.string(),
      flags: z.object({
        optional: z["boolean"](),
        applyboardRequirement: z["boolean"](),
        applyproofCompatible: z["boolean"](),
        earlyAccess: z["boolean"](),
        official: z["boolean"](),
        requiresFormPreparation: z["boolean"]()
      }),
      externalLinks: z.array(z.object({
        link: z.string(),
        id: z.number().optional()
      })),
      published: z["boolean"](),
      evaluationWorkflow: Workflow.nullable(),
      formDefinition: FormDefinition.nullable()
    })
  })
});
export function useCreateRequirementTemplate() {
  var _useRequirementPageMu = useRequirementPageMutation(function (_ref) {
      var form = _ref.form,
        generalInformation = _ref.generalInformation,
        published = _ref.published,
        workflow = _ref.workflow;
      return {
        url: '/requirement-template',
        method: 'POST',
        body: {
          data: {
            type: 'requirement_template_creation_request',
            attributes: {
              title: generalInformation.title,
              internal_title: generalInformation.internalTitle,
              category: generalInformation.category,
              tags: generalInformation.tags,
              classification: generalInformation.classification,
              application_stage: generalInformation.applicationStage,
              description: generalInformation.description,
              internal_description: generalInformation.internalDescription,
              flags: {
                applyboard_requirement: generalInformation.applyboardRequirement,
                applyproof_compatible: generalInformation.applyproofCompatible,
                early_access: generalInformation.earlyAccess,
                official: generalInformation.official,
                optional: generalInformation.optional,
                requires_form_preparation: generalInformation.requiresFormPreparation
              },
              external_links: generalInformation.externalLinks,
              published: published,
              evaluation_workflow: workflow,
              form_definition: form
            }
          }
        }
      };
    }),
    mutate = _useRequirementPageMu.mutate,
    isLoading = _useRequirementPageMu.isLoading;
  return {
    createRequirementTemplate: mutate,
    isCreatingRequirementTemplate: isLoading
  };
}
export function useUpdateRequirementTemplate() {
  var _useRequirementPageMu2 = useRequirementPageMutation(function (_ref2) {
      var id = _ref2.id,
        form = _ref2.form,
        generalInformation = _ref2.generalInformation,
        published = _ref2.published,
        workflow = _ref2.workflow;
      return {
        url: "/awa/v1/requirement_templates/".concat(id),
        method: 'PATCH',
        body: {
          data: {
            type: 'requirement_template_update_request',
            attributes: {
              title: generalInformation.title,
              internalTitle: generalInformation.internalTitle,
              category: generalInformation.category,
              tags: generalInformation.tags,
              classification: generalInformation.classification,
              applicationStage: generalInformation.applicationStage,
              description: generalInformation.description,
              internalDescription: generalInformation.internalDescription,
              flags: {
                applyboardRequirement: generalInformation.applyboardRequirement,
                applyproofCompatible: generalInformation.applyproofCompatible,
                earlyAccess: generalInformation.earlyAccess,
                official: generalInformation.official,
                optional: generalInformation.optional,
                requiresFormPreparation: generalInformation.requiresFormPreparation
              },
              externalLinks: generalInformation.externalLinks,
              published: published,
              evaluationWorkflow: workflow,
              formDefinition: form
            }
          }
        }
      };
    }),
    mutate = _useRequirementPageMu2.mutate,
    isLoading = _useRequirementPageMu2.isLoading;
  return {
    updateRequirementTemplate: mutate,
    isUpdatingRequirementTemplate: isLoading
  };
}